//=================================================
//    summary: DCP 購買 分頁 -- Hook
//              自動購買流程 還沒串
//              購買錯誤流程 還沒詳測
//
//    remarks: 000 Tim 2021/11/15 Create
//             001 Tim 2021/12/23 加入 PaintedMe流程
//             002 Tim 2022/09/01 產品圖片 改讀 Web路徑
//================================================
import React, { useState, useEffect, useRef } from 'react'
import cssSubscription from './Subscription.module.scss'
import {LocalStorageLibs, ClientGatewayInPackage, GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region State Member Variables
let mstrStateCode01InputValue = ""
let mstrStateCode02InputValue = ""
let mstrStateCode03InputValue = ""
let mstrStateCode04InputValue = ""
// #endregion State Member Variables

// #region Member Variables
let mblnInitialized = false

let mobjCallParam = null
let mblnIsExecuteExit = false
// #endregion Member Variables

// #region Const
const MAX_CODE_CHARACHERS = 4 // input Text 最大的數字限制
// #endregion Const


const COMP_NAME = "Subscription"

function Subscription(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [updateDataTime, setUpdateDataTime] = useState(0)

    const [code01InputValue, setCode01InputValue] = useState("")
    const [code02InputValue, setCode02InputValue] = useState("")
    const [code03InputValue, setCode03InputValue] = useState("")
    const [code04InputValue, setCode04InputValue] = useState("")
    // #endregion Init State

    // #region Init Function Ref
    let mrefPaintedMe = useRef(null)
    
    mrefPaintedMe.current = PaintedMe
    // #endregion Init Function Ref

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Update code01InputValue
    useEffect(() => {
        mstrStateCode01InputValue = code01InputValue
    }, [code01InputValue])

    // Update code02InputValue
    useEffect(() => {
        mstrStateCode02InputValue = code02InputValue
    }, [code02InputValue])

    // Update code03InputValue
    useEffect(() => {
        mstrStateCode03InputValue = code03InputValue
    }, [code03InputValue])

    // Update code04InputValue
    useEffect(() => {
        mstrStateCode04InputValue = code04InputValue
    }, [code04InputValue])

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        mrefPaintedMe.current()

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
            setUpdateDataTime(0)
            setCode01InputValue("")
            setCode02InputValue("")
            setCode03InputValue("")
            setCode04InputValue("")
        }
    }, [props.AuthorizedSubscription])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 Web 授權碼 送出按鈕
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SubmitOnTapHandler()
    {
        console.log(COMP_NAME + ".SubmitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        let strCode01 = mstrStateCode01InputValue.trim()
        let strCode02 = mstrStateCode02InputValue.trim()
        let strCode03 = mstrStateCode03InputValue.trim()
        let strCode04 = mstrStateCode04InputValue.trim()

        console.log(COMP_NAME + ".SubmitOnTapHandler strCode01: ", strCode01)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode02: ", strCode02)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode03: ", strCode03)
        console.log(COMP_NAME + ".SubmitOnTapHandler strCode04: ", strCode04)

        if (
            (strCode01.length === 4) &&
            (strCode02.length === 4) &&
            (strCode03.length === 4) &&
            (strCode04.length === 4)
            )
        {
            let strCode = strCode01 + strCode02 + strCode03 + strCode04

            console.log("strCode: ", strCode)
            
            mobjCallParam = {
                "AuthCode": strCode
            }
            AuthProvisioning()
        }
        else 
        {
            let objAlertObject = {
                Header: "",
                Body: window.gAppUI.ERR_AuthorizationCode,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }
    } // end of SubmitOnTapHandler

    /*===========================================
    summary: 點選 Web 購買產品元件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function WebProductUnitOnTapHandler(ReminderIndex)
    {
        console.log(COMP_NAME + ".WebProductUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        window.open(window.gSession.Acc.SubscriptionReminder.Reminder[ReminderIndex].Link)

        let intCouterType = 3;        // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
        let intItemType = parseInt(window.gSession.Acc.SubscriptionReminder.Reminder[ReminderIndex].ItemType);            // 各按鈕編號 

        mobjCallParam = {
            "AccountID": window.gSession.Acc.ID,
            "CouterType": intCouterType,               // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
            "ItemType": intItemType                    // 各按鈕編號 
        }
        UpdateProductCounter()
    } // end of WebProductUnitOnTapHandler

    /*===========================================
    summary: 點選 App 購買產品元件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function AppProductUnitOnTapHandler(BookIndex)
    {
        console.log(COMP_NAME + ".AppProductUnitOnTapHandler")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        if (navigator.onLine)
        {
            let intBookSeqNo = (BookIndex + 1)
            if(window.gSession.App.iOSNewGateway)
            {
                OpenLoadingMask(window.gAppUI.MSG_LoadMask_ProcessInAppPurchase)
                OpenIAPFromAppSwiftUI(intBookSeqNo)
            }
            else
            {
                OpenIAPFromApp(window.gSession.App.BookCatID, intBookSeqNo)
            }            
        }
        else
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg)
        }
    } // end of AppProductUnitOnTapHandler
    // #endregion OnTapHandler

    // #region Other EventHandler
    /*===========================================
    summary: Code 輸入框 改變事件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function CodeChangeHandler(e, TextID)
    {
        console.log(COMP_NAME + ".CodeChangeHandler: ", e)

        switch (TextID) 
        {
            case 2:
                setCode02InputValue(e.target.value)
                break
            case 3:
                setCode03InputValue(e.target.value)
                break
            case 4:
                setCode04InputValue(e.target.value)
                break
            case 1:
            default:
                setCode01InputValue(e.target.value)
                break
        } // end of switch
    } // end of CodeChangeHandler
    // #endregion Other EventHandler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/10/08 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region AlertCallBack
    /*===========================================
    summary: 授權 更新成功 Alert CallBack
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SubmitSuccessAlertCallBack ()
    {
        console.log(COMP_NAME + ".SubmitSuccessAlertCallBack")
        
        mobjCallParam = {
            "BundleID": window.gConst.BUNDLE_ID,
            "AppVersion": process.env.REACT_APP_LOG_VERSION,
            "BookCategoryID": 0                                 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
        }
        GetAccountAuthorized()
    } // end of SubmitSuccessAlertCallBack

    /*===========================================
    summary: Web 產品 購買後，需要跳 更新授權提示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function WebProductUnitAfterProcessAlertCallBack (BtnObject)
    {
        console.log(COMP_NAME + ".WebProductUnitAfterProcessAlertCallBack");
        
        if (BtnObject.index === 1) // BTN_OK
        {
            mobjCallParam = {
                "BundleID": window.gConst.BUNDLE_ID,
                "AppVersion": process.env.REACT_APP_LOG_VERSION,
                "BookCategoryID": 0                                 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
            }
            GetAccountAuthorized()
        }
    } // end of WebProductUnitAfterProcessAlertCallBack
    // #endregion AlertCallBack

    // #region Other Functions
    /*===========================================
    summary: componentDidMount 程式進入 處理Props資料
    remarks: 000 Tim 2021/12/23 Create
    ===========================================*/
    function PaintedMe()
    {
        console.log(COMP_NAME + ".PaintedMe")

        if (
            (typeof(props.AuthorizedSubscription) !== 'undefined') &&
            (props.AuthorizedSubscription !== null) &&
            (typeof(props.AuthorizedSubscription.BookCatID) !== 'undefined') &&
            (props.AuthorizedSubscription.BookCatID !== null) &&
            (parseInt(props.AuthorizedSubscription.BookCatID) > 0) &&
            (typeof(props.AuthorizedSubscription.BookSeqNo) !== 'undefined') &&
            (props.AuthorizedSubscription.BookSeqNo !== null) &&
            (parseInt(props.AuthorizedSubscription.BookSeqNo) > 0)
            )
        {
            OpenIAPFromApp(props.AuthorizedSubscription.BookCatID, props.AuthorizedSubscription.BookSeqNo)
        }

        setUpdateDataTime(new Date().getTime())
    } // end of PaintedMe

    /*===========================================
    summary: 取得 授權 物件
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetAuthorizedObject (BookSeqNo)
    {
        var objAuthorized = null;

        if (window.gSession.Acc.AccountAuthorized !== null)
        {
            objAuthorized = window.Globals.GetAuthorized(window.gSession.Acc.AccountAuthorized, window.gSession.App.BookCatID, BookSeqNo);
        }  

        return objAuthorized;    
    } // end of GetAuthorizedObject
    // #endregion Other Functions

    // #region Get ClassName
    /*===========================================
    summary: 取得 Order Now Button Cls
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetOrderNowButtonCls(IsDefault)
    {
        let objCls = cssSubscription.divOrderNowButton

        if (IsDefault === 1)
        {
            objCls = cssSubscription.divOrderNowButtonDefault
        }

        return objCls
    } // end of GetOrderNowButtonCls

    /*===========================================
    summary: 取得 App 產品 元件 Cls
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetAppProductUnitCls(BookIndex)
    {
        let objCls = cssSubscription.divAppProductUnit

        if (BookIndex === (window.gSession.App.BookCategoryDef.Book.length - 1))
        {
            objCls = cssSubscription.divAppProductUnitLast
        }

        return objCls
    } // end of GetAppProductUnitCls
    // #endregion Get ClassName

    // #region Call App Service
    /*===========================================
    summary: App 開啟購買授權頁面
    remarks: 000 Tim 2021/11/15 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
             002 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function OpenIAPFromApp (BookCategoryID, BookSeqNo)
    {
        const FUNC_NAME = OpenIAPFromApp.name
        console.log(COMP_NAME + "." + FUNC_NAME + ": ", BookCategoryID, BookSeqNo)
        
        let strBookCategoryID = BookCategoryID.toString().PadLeft(2)    // 左邊補零 Format "01"
        let strBookSeqNo = BookSeqNo.toString().PadLeft(2)              // 左邊補零 Format "01"

        // open loading mask?

        let intAction = window.gConst.ACTION_OPEN_IAP
        let strQueryString = "Action=" + intAction 
        strQueryString += "&Credential=&BackRoute="
        strQueryString += "&BookCategoryID=" + strBookCategoryID
        strQueryString += "&BookSeqNo=" + strBookSeqNo

        console.log("strQueryString: ", strQueryString)
        // window.gSession.App.AppCallbackRef = BackFromAppCallbackOpenIAPFromApp
        // window.ComponentFuncEntry.SettingsRef = AppIAPResultHandler
        // window.ComponentFuncEntry.InAppPurchaseRef = AppIAPResultHandler
        ClientGatewayInPackage.RegisterFuncRef4AppInAppPurchaseResultHandler(AppIAPResultHandler)
        
        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway, BackFromAppCallbackOpenIAPFromApp)
        ClientGatewayInPackage.CallApp(strQueryString, BackFromAppCallbackOpenIAPFromApp)
    } // end of OpenIAPFromApp

    /*===========================================
    summary: App 開啟購買授權頁面 Callback
    remarks: 000 Tim 2021/11/15 Create
             001 Tim 2023/06/19 處理 AppCallbackRef 反註冊
    ===========================================*/
    function BackFromAppCallbackOpenIAPFromApp (ReturnData) 
    {
        console.log(COMP_NAME + ".BackFromAppCallbackOpenIAPFromApp: ", ReturnData)

        if (ReturnData.Status !== window.gDataStatusFromAppIAPEnum.Cancel)
        {
            let intResultCode = ReturnData.ResultCode
            let intResultSubCode = ReturnData.ResultSubCode
            console.log("intResultCode, intResultSubCode: ", intResultCode, intResultSubCode)

            // Note that:
            // Offline 判斷留給原來的流程
            if (
                (intResultCode !== 1) && 
                (intResultCode !== window.gConst.APP_RETURN_ERROR_NETWORK_OFFLINE)
                )
            {
                // error handling
                let strErrMsg = ""
                let strErrTitle = ""
                let blnExceptionError = false

                // you need to customize these
                let intDefaultErrNo = window.gAppUI.ERR_App_OpenIAP_No
                let strDefaultErrorTitle = window.gAppUI.ERR_App_OpenIAP_Title
                let strDefaultErrMsg = window.gAppUI.ERR_App_OpenIAP_Msg

                console.log("intResultCode, intResultSubCode: ", intResultCode, intResultSubCode)
                if (intResultCode === window.gConst.APP_RETURN_ERROR_CMS_WS_FAILED)
                {
                    // CMS WS failed
                    let blnCredentialFailed = NetworkLibs.IsCredentialError(intResultSubCode)
                    if (blnCredentialFailed)
                    {
                        // strBackRoute = "Settings.OpenIAPFromApp";
                        // window.Globals.CredentialFailedErrorHandler(intResultSubCode, strBackRoute);
                        NetworkLibs.CredentialFailedErrorHandler(intResultSubCode)
                    }
                    else
                    {
                        strErrTitle = strDefaultErrorTitle
                        strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + strDefaultErrMsg + "(" + intResultSubCode + ")"
                        blnExceptionError = true
                        // GlobalLibs.OkErrorHandler(strDefaultErrorTitle, strErrMsg)
                    }
                }
                else
                {
                    // newtork error or others (目前沒有 others)
                    switch (intResultCode)
                    {
                        case window.gConst.APP_RETURN_ERROR_NETWORK_TIMEOUT: // Network Timeout
                            strErrTitle = window.gAppUI.ERR_WSTimeout_Title
                            strErrMsg = "(" + PackageVariablesLibs.UISettings.ERR_WSTimeout_No.toString() + ") " + window.gAppUI.ERR_WSTimeout_Msg
                            blnExceptionError = true
                            break
                        case window.gConst.APP_RETURN_ERROR_NETWORK_SERVICE_IS_NOT_REACHABLE: // Service is not Reachable
                            strErrTitle = window.gAppUI.ERR_WSNetworkGeneric_Title
                            strErrMsg = "(" + window.gAppUI.ERR_WSNetworkGeneric_No.toString() + ") " + window.gAppUI.ERR_WSNetworkGeneric_Msg
                            blnExceptionError = true
                            break
                        default:
                            strErrTitle = strDefaultErrorTitle
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + strDefaultErrMsg + "(" + intResultSubCode + ")"
                            blnExceptionError = true
                            break
                    }
                    // GlobalLibs.OkErrorHandler(strErrTitle, strErrMsg)
                }

                if (blnExceptionError)
                {
                    // 有需要 另外跳 錯誤訊息
                    console.log("BackFromAppCallbackOpenIAPFromApp: ExceptionError")

                    let objAlertObject = {
                        Header: strErrTitle,
                        Body: strErrMsg,
                        ShowCloseButton: false,
                        CallbackRef: null,
                        Buttons: [
                            {
                                Text: PackageVariablesLibs.UISettings.BTN_OK,
                                AutoFocus: true
                            }
                        ]
                    }
                    ShowAlert(objAlertObject)
                } // end of if (blnExceptionError)
            }
            else
            {
                // 沒有錯誤
                console.log(COMP_NAME + ".BackFromAppCallbackOpenIAPFromApp Status: ", ReturnData.Status);
            }
        } // end of if (ReturnData.Status !== window.gDataStatusFromAppIAPEnum.Cancel)
        // window.gSession.App.AppCallbackRef = null
    } // end of BackFromAppCallbackOpenIAPFromApp

    /*===========================================
    summary: App 開啟購買流程 SwiftUI
    remarks: 000 XXX 20XX/XX/XX Create
             001 Tim 2023/08/18 改寫 ClientGatewayInPackage.CallApp(
                                參數 要改用 最新版本 QueryString, CallbackFuncRef
    ===========================================*/
    function OpenIAPFromAppSwiftUI(BookSeqNo)
    {
        console.log(COMP_NAME + ".OpenIAPFromAppSwiftUI: ", BookSeqNo)
        
        let strProductID = ""
        switch(parseInt(BookSeqNo))
        {
            case 1:
                strProductID = window.gConst.IN_APP_PURCHASE_PRODUCT_ID_VOLUME_01 // "APP_DCP_V1_1Y_NON_RENEWING"
                break;
            case 2:
                strProductID = window.gConst.IN_APP_PURCHASE_PRODUCT_ID_VOLUME_02 // "APP_DCP_V2_1Y_NON_RENEWING"
                break;
            case 3:
                strProductID = window.gConst.IN_APP_PURCHASE_PRODUCT_ID_VOLUME_03 // "APP_DCP_V3_1Y_NON_RENEWING"
                break;
            case 4:
                strProductID = window.gConst.IN_APP_PURCHASE_PRODUCT_ID_VOLUME_04 //"APP_DCP_V4_1Y_NON_RENEWING_2"
                break;
            default:
                break
        }

        let intAction = window.gConst.ACTION_InAppPurchaseWIthProductID
        let strQueryString = "Action=" + intAction 
        strQueryString += "&Credential="
        strQueryString += "&BackRoute="
        strQueryString += "&ProductID=" + strProductID
        
        console.log(COMP_NAME + ".OpenIAPFromAppSwiftUI strQueryString: ", strQueryString)
        // window.ComponentFuncEntry.InAppPurchaseRef = AppInAppPurchaseResultHandlerSwiftUI
        ClientGatewayInPackage.RegisterFuncRef4AppInAppPurchaseResultHandler(AppInAppPurchaseResultHandlerSwiftUI)
        
        // ClientGatewayInPackage.CallApp(strQueryString, window.CallAppAPI, window.gSession.App.InApp, window.gSession.App.iOSNewGateway)
        ClientGatewayInPackage.CallApp(strQueryString)
    } // end of OpenIAPFromApp
    // #endregion Call App Service

    // #region App Call Web 

    // App In App Purchase - iOS 購買結束後 丟出結果
    function AppInAppPurchaseResultHandlerSwiftUI(ReturnData)
    {
        console.log(COMP_NAME + ".AppInAppPurchaseResultHandlerSwiftUI: ", ReturnData)

        // window.ComponentFuncEntry.InAppPurchaseRef = null
        ClientGatewayInPackage.UnregisterFuncRef4AppInAppPurchaseResultHandler()

        CloseLoadingMask()

        let intResultCode = parseInt(ReturnData.ResultCode)
        

        let intDefaultErrNo = window.gAppUI.ERR_App_OpenIAP_No
        let strDefaultErrorTitle = window.gAppUI.ERR_App_OpenIAP_Title
        let strDefaultErrMsg = window.gAppUI.ERR_App_OpenIAP_Msg

        let strErrTitle = strDefaultErrorTitle
        let strErrMsg = strDefaultErrMsg

        let strResultMsg = ""
        if (
            (typeof(ReturnData.ResultMsg)) !== "undefined" &&
            ReturnData.ResultMsg !== null &&
            ReturnData.ResultMsg !== ""
        )
        {
            // 目前只有ResultCode: -99 才有ResultMsg
            strResultMsg = " (" + ReturnData.ResultMsg + ")"
        }
        
        if(intResultCode === window.gResultCodeForAppInAppPurchaseSwiftUIEnum.Successfully)
        {
            // 購買成功
            console.log("In App Purchase - Successfully")

            // 重新取得授權
            mobjCallParam = {
                "BundleID": window.gConst.BUNDLE_ID,
                "AppVersion": process.env.REACT_APP_LOG_VERSION,
                "BookCategoryID": 0 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
            }
            GetAccountAuthorized()
        }
        else if (intResultCode === window.gResultCodeForAppInAppPurchaseSwiftUIEnum.Cancel)
        {
            // 點取消

            // 不做任何處理
            console.log("In App Purchase - Cancel")
        }
        else
        {
            console.log("In App Purchase - Fail")
            // 購買過程有錯誤

            // SwiftUI版的 InAppPurhcase 購買後傳資訊給React 不回傳網路狀態 Credential狀態

            switch(intResultCode)
            {
                case window.gResultCodeForAppInAppPurchaseSwiftUIEnum.ErrorDefault: 
                    strErrTitle = window.gAppUI.ERR_iOSInAppPurchaseErrorDefault_Title
                    strErrMsg = window.gAppUI.ERR_iOSInAppPurchaseErrorDefault_No.toString() + ": " + window.gAppUI.ERR_iOSInAppPurchaseErrorDefault_Msg + (strResultMsg !== "" ? "(" + strResultMsg + ")" : "")
                    break
                case window.gResultCodeForAppInAppPurchaseSwiftUIEnum.ErrorProductIDFailed: 
                    strErrTitle = window.gAppUI.ERR_iOSInAppPurchaseProductIDFail_Title
                    strErrMsg = window.gAppUI.ERR_iOSInAppPurchaseProductIDFail_No.toString() + ": " + window.gAppUI.ERR_iOSInAppPurchaseProductIDFail_Msg + (strResultMsg !== "" ? "(" + strResultMsg + ")" : "")
                    break
                case window.gResultCodeForAppInAppPurchaseSwiftUIEnum.ErrorCMSWebServiceFailed:
                    
                    let intResultSubCode = parseInt(ReturnData.ResultSubCode)
                    
                    strErrTitle = window.gAppUI.ERR_iOSInAppPurchaseErrorWebServiceFailed_Title
                    strErrMsg = window.gAppUI.ERR_iOSInAppPurchaseErrorWebServiceFailedd_No.toString() + ": " + window.gAppUI.ERR_iOSInAppPurchaseErrorWebServiceFail_Msg + (strResultMsg !== "" ? "(" + strResultMsg + ")" : "")

                    switch (intResultSubCode)
                    {
                        case window.gConst.RECEIPT_NOT_VALID:                  // -120063, // 購買 收據無效
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_ReceiptNotValidMsg + "(" + intResultSubCode + ")"
                            break
                        case window.gConst.SOMEBODY_IS_REUSING_A_RECEIPT:      // -120064, // 購買 收據重複
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_SomebodyIsReusingAReceiptMsg + "(" + intResultSubCode + ")"
                            break
                        case window.gConst.RECEIPT_PRODUCT_ID_ERROR:           // -120065, // 購買 收據ID錯誤
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_ReceiptProductIDErrorMsg + "(" + intResultSubCode + ")"
                            break
                        case window.gConst.AUTHORIZATION_DEFAULT_ERROR:        // -120057, // 購買 預設未定義錯誤
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_AuthorizationDefaultErrorMsg + "(" + intResultSubCode + ")"
                            break
                        case window.gConst.AUTHORIZATION_NOT_RESPONSE:        // -120058, // 購買 收到錯誤訊息的預設錯誤
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_AuthorizationNotResponseMsg + "(" + intResultSubCode + ")"
                            break
                        default:
                            strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + strDefaultErrMsg + "(" + intResultSubCode + ")"
                            break
                    }
                    break
                case window.gResultCodeForAppInAppPurchaseSwiftUIEnum.ErrorNoReceiptFailed:
                    strErrTitle = window.gAppUI.ERR_iOSInAppPurchaseErrorNoReceiptFailed_Title
                    strErrMsg = window.gAppUI.ERR_iOSInAppPurchaseErrorNoReceiptFailed_No.toString() + ": " + window.gAppUI.ERR_iOSInAppPurchaseErrorNoReceiptFailed_Msg + (strResultMsg !== "" ? "(" + strResultMsg + ")" : "")
                    break
                case window.gResultCodeForAppInAppPurchaseSwiftUIEnum.ErrorReceiptDataProcessedFailed:
                    strErrTitle = window.gAppUI.ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_Title
                    strErrMsg = window.gAppUI.ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_No.toString() + ": " + window.gAppUI.ERR_iOSInAppPurchaseErrorReceiptDataProcessedFailed_Msg + (strResultMsg !== "" ? "(" + strResultMsg + ")" : "")
                    break
                default:
                    break
            }

            let objAlertObject = {
                Header: strErrTitle,
                Body: strErrMsg,
                ShowCloseButton: false,
                CallbackRef: null,
                Buttons: [
                    {
                        Text: PackageVariablesLibs.UISettings.BTN_OK,
                        AutoFocus: true
                    }
                ]
            }
            ShowAlert(objAlertObject)
        }                
    }

    /*===========================================
    summary: App 購買授權 結果
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function AppIAPResultHandler (ReturnData)
    {
        console.log(COMP_NAME + ".AppIAPResultHandler: ", ReturnData)

        // {
        //     "ResultCode": 1,
        //     "ResultSubCode": 1,
        //     "Status": 1,
        //     "Purchased": 1
        // }

        if (ReturnData.Status !== window.gDataStatusFromAppIAPEnum.Cancel)
        {
            let intResultCode = ReturnData.ResultCode
            let intResultSubCode = ReturnData.ResultSubCode

            let intDefaultErrNo = window.gAppUI.ERR_App_OpenIAP_No
            let strDefaultErrorTitle = window.gAppUI.ERR_App_OpenIAP_Title
            let strDefaultErrMsg = window.gAppUI.ERR_App_OpenIAP_Msg

            let blnCredentialFailed = false

            let strErrMsg = ""
            let strErrTitle = ""
            let blnExceptionError = false
            let objAlertObject = null

            console.log("intResultCode, intResultSubCode: ", intResultCode, intResultSubCode)

            window.gSession.App.AppIAPResult = false;       // true 需要等 App IAP Result， false 不用處理   Tim17.04.26
            
            // Purchased : false IAP procedure haven’t completed
            //             true IAP procedure completed
            if (ReturnData.Purchased)
            {
                // Note that:
                // Offline 判斷留給原來的流程
                if (
                    (intResultCode !== 1) && 
                    (intResultCode !== window.gConst.APP_RETURN_ERROR_NETWORK_OFFLINE)
                    )
                {
                    // error handling

                    // you need to customize these
                    console.log("intResultCode, intResultSubCode: ", intResultCode, intResultSubCode);
                    if (intResultCode === window.gConst.APP_RETURN_ERROR_CMS_WS_FAILED)
                    {
                        // CMS WS failed
                        blnCredentialFailed = NetworkLibs.IsCredentialError(intResultSubCode);
                        if (blnCredentialFailed)
                        {
                            // strBackRoute = "Settings.GetAccountAuthorized";
                            window.gSession.App.AppIAPResult = true       // true 需要等 App IAP Result， false 不用處理   Tim17.04.26
                            NetworkLibs.CredentialFailedErrorHandler(intResultSubCode)
                        }
                        else
                        {
                            blnExceptionError = true
                            strErrTitle = strDefaultErrorTitle
                            switch (intResultSubCode)
                            {
                                case window.gConst.RECEIPT_NOT_VALID:                  // -120063, // 購買 收據無效
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_ReceiptNotValidMsg + "(" + intResultSubCode + ")"
                                    break
                                case window.gConst.SOMEBODY_IS_REUSING_A_RECEIPT:      // -120064, // 購買 收據重複
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_SomebodyIsReusingAReceiptMsg + "(" + intResultSubCode + ")"
                                    break
                                case window.gConst.RECEIPT_PRODUCT_ID_ERROR:           // -120065, // 購買 收據ID錯誤
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_ReceiptProductIDErrorMsg + "(" + intResultSubCode + ")"
                                    break
                                case window.gConst.AUTHORIZATION_DEFAULT_ERROR:        // -120057, // 購買 預設未定義錯誤
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_AuthorizationDefaultErrorMsg + "(" + intResultSubCode + ")"
                                    break
                                case window.gConst.AUTHORIZATION_NOT_RESPONSE:        // -120058, // 購買 收到錯誤訊息的預設錯誤
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_AuthorizationNotResponseMsg + "(" + intResultSubCode + ")"
                                    break
                                default:
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + strDefaultErrMsg + "(" + intResultSubCode + ")"
                                    break
                            }
                            // GlobalLibs.OkErrorHandler(strDefaultErrorTitle, strErrMsg)
                        }
                    }
                    else
                    {
                        blnExceptionError = true
                        // newtork error or others (目前沒有 others)
                        switch (intResultCode)
                        {
                            case window.gConst.APP_RETURN_ERROR_NETWORK_TIMEOUT: // Network Timeout
                                strErrTitle = window.gAppUI.ERR_WSTimeout_Title
                                strErrMsg = "(" + PackageVariablesLibs.UISettings.ERR_WSTimeout_No.toString() + ") " + window.gAppUI.ERR_WSTimeout_Msg
                                break
                            case window.gConst.APP_RETURN_ERROR_NETWORK_SERVICE_IS_NOT_REACHABLE: // Service is not Reachable
                                strErrTitle = window.gAppUI.ERR_WSNetworkGeneric_Title
                                strErrMsg = "(" + window.gAppUI.ERR_WSNetworkGeneric_No.toString() + ") " + window.gAppUI.ERR_WSNetworkGeneric_Msg
                                break
                            case window.gConst.APP_RETURN_ERROR_NETWORK_OFFLINE: // Netwrok Offline
                                strErrTitle = window.gAppUI.ERR_InternetRequired_Title
                                strErrMsg = "(" + PackageVariablesLibs.UISettings.ERR_InternetRequired_No.toString() + ") " + window.gAppUI.ERR_InternetRequired_Msg
                                break
                            default:
                                strErrTitle = strDefaultErrorTitle
                                strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + strDefaultErrMsg + "(" + intResultSubCode + ")"
                                break
                        }
                        // GlobalLibs.OkErrorHandler(strErrTitle, strErrMsg);
                    }

                    if (blnExceptionError)
                    {
                        // 有需要 另外跳 錯誤訊息
                        console.log("AppIAPResultHandler: ExceptionError")

                        objAlertObject = {
                            Header: strErrTitle,
                            Body: strErrMsg,
                            ShowCloseButton: false,
                            CallbackRef: null,
                            Buttons: [
                                {
                                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                                    AutoFocus: true
                                }
                            ]
                        }
                        ShowAlert(objAlertObject)
                    } // end of if (blnExceptionError)
                }
                else
                {
                    // 沒有錯誤
                    console.log(COMP_NAME + ".AppIAPResultHandler Status: ", ReturnData.Status)
                    
                    mobjCallParam = {
                        "BundleID": window.gConst.BUNDLE_ID,
                        "AppVersion": process.env.REACT_APP_LOG_VERSION,
                        "BookCategoryID": 0                                 // 特殊處理，當 BookCategoryID = 0 是， 把 BookCategoryID 1, 3 的授權都回傳
                    }
                    GetAccountAuthorized()
                }
            }
            else
            {
                // Note that:
                // Offline 判斷留給原來的流程
                if (
                    (intResultCode !== 1) && 
                    (intResultCode !== window.gConst.APP_RETURN_ERROR_NETWORK_OFFLINE)
                    )
                {
                    // error handling

                    // you need to customize these
                    console.log("intResultCode, intResultSubCode: ", intResultCode, intResultSubCode);
                    if (intResultCode === window.gConst.APP_RETURN_ERROR_CMS_WS_FAILED)
                    {
                        // CMS WS failed
                        blnCredentialFailed = NetworkLibs.IsCredentialError(intResultSubCode);
                        if (blnCredentialFailed)
                        {
                            NetworkLibs.CredentialFailedErrorHandler(intResultSubCode);
                        }
                        else
                        {
                            blnExceptionError = true
                            strErrTitle = strDefaultErrorTitle
                            switch (intResultSubCode)
                            {
                                default:
                                    strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_IAPProcedureHavenotCompleted + "(" + intResultSubCode + ")"
                                    break
                            }
                            // GlobalLibs.OkErrorHandler(strDefaultErrorTitle, strErrMsg);
                        }
                    }
                    else
                    {
                        blnExceptionError = true
                        // newtork error or others (目前沒有 others)
                        switch (intResultCode)
                        {
                            case window.gConst.APP_RETURN_ERROR_NETWORK_TIMEOUT: // Network Timeout
                                strErrTitle = window.gAppUI.ERR_WSTimeout_Title
                                strErrMsg = "(" + PackageVariablesLibs.UISettings.ERR_WSTimeout_No.toString() + ") " + window.gAppUI.ERR_WSTimeout_Msg
                                break
                            case window.gConst.APP_RETURN_ERROR_NETWORK_SERVICE_IS_NOT_REACHABLE: // Service is not Reachable
                                strErrTitle = window.gAppUI.ERR_WSNetworkGeneric_Title
                                strErrMsg = "(" + window.gAppUI.ERR_WSNetworkGeneric_No.toString() + ") " + window.gAppUI.ERR_WSNetworkGeneric_Msg
                                break
                            case window.gConst.APP_RETURN_ERROR_NETWORK_OFFLINE: // Netwrok Offline
                                strErrTitle = window.gAppUI.ERR_InternetRequired_Title
                                strErrMsg = "(" + PackageVariablesLibs.UISettings.ERR_InternetRequired_No.toString() + ") " + window.gAppUI.ERR_InternetRequired_Msg
                                break
                            default:
                                strErrTitle = strDefaultErrorTitle
                                strErrMsg = '(' + intDefaultErrNo.toString() + ') ' + window.gAppUI.ERR_IAPProcedureHavenotCompleted + "(" + intResultSubCode + ")"
                                break
                        }
                        // GlobalLibs.OkErrorHandler(strErrTitle, strErrMsg);
                    }

                    if (blnExceptionError)
                    {
                        // 有需要 另外跳 錯誤訊息
                        console.log("AppIAPResultHandler: 2 ExceptionError")

                        objAlertObject = {
                            Header: strErrTitle,
                            Body: strErrMsg,
                            ShowCloseButton: false,
                            CallbackRef: null,
                            Buttons: [
                                {
                                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                                    AutoFocus: true
                                }
                            ]
                        }
                        ShowAlert(objAlertObject)
                    } // end of if (blnExceptionError)
                }
            }
        } // end of if (ReturnData.Status != DCP.app.gDataStatusFromAppIAPEnum.Cancel)
        // window.ComponentFuncEntry.SettingsRef = null
        // window.ComponentFuncEntry.InAppPurchaseRef = null
        ClientGatewayInPackage.UnregisterFuncRef4AppInAppPurchaseResultHandler()
    } // end of AppIAPResultHandler
    
    // #endregion App Call Web

    // #region Web Service After Process
    /*===========================================
    summary: 儲存 帳號設定後 的 流程
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function SetAccountPreferencesAfterProcess ()
    {   
        console.log(COMP_NAME + ".GetAccountDashboardAfterProcess")

        // save to local storage
        LocalStorageLibs.SetAccLSElement("Preferences", JSON.stringify(window.gSession.Acc.Preferences))

        mobjCallParam = null
    } // end of SetAccountPreferencesAfterProcess

    /*===========================================
    summary: 更新 按鈕 計次後 的 流程
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function UpdateProductCounterAfterProcess ()
    {   
        console.log(COMP_NAME + ".UpdateProductCounterAfterProcess")
        mobjCallParam = null

        if (window.gSession.Acc.Preferences.SRShow !== 1)
        {
            mobjCallParam = {
                "AccPreferences": []
            }

            let objPref = {
                "Key": window.gAccPreferenceTypeEnum.SRShow,
                "Value": window.gSession.Acc.Preferences.SRShow
            }
            mobjCallParam.AccPreferences.push(objPref)

            SetAccountPreferences()
        } // end of if (window.gSession.Acc.Preferences.SRShow !== 1)

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_Alert_Web_Subscribe_Successfully,
            ShowCloseButton: false,
            CallbackRef: WebProductUnitAfterProcessAlertCallBack,
            Buttons: [
                {
                    Text: window.gAppUI.BTN_Cancel,
                    AutoFocus: false
                },
                {
                    Text: window.gAppUI.BTN_Update,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)
    } // end of UpdateProductCounterAfterProcess

    /*===========================================
    summary: 取得 使用者 授權 後續流程
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetAccountAuthorizedAfterProcess (ReturnData)
    {
        console.log(COMP_NAME + ".GetAccountAuthorizedAfterProcess")

        // Session Variables
        window.gSession.Acc.AccountAuthorized = JSON.parse(JSON.stringify(ReturnData))

        // LS
        LocalStorageLibs.SetAccLSElement("Authorized", JSON.stringify(window.gSession.Acc.AccountAuthorized))
        
        console.log(COMP_NAME + ".GetAccountAuthorizedAfterProcess props.AuthorizedSubscription: ", props.AuthorizedSubscription)
        if (
            (typeof(props.AuthorizedSubscription) !== 'undefined') &&
            (props.AuthorizedSubscription !== null)
            )
        {
            if (props.AuthorizedSubscription.SubscriptionType === window.gAuthorizedSubscriptionTypeEnum.Resource)
            {
                let objCallbackData = {
                    "Action": "OpenShowResource4NoAuthorized"
                }
                props.CallbackRef(objCallbackData)
            }
            else if (props.AuthorizedSubscription.SubscriptionType === window.gAuthorizedSubscriptionTypeEnum.AssignReport)
            {
                let objCallbackData = {
                    "Action": "AssignReport4NoAuthorized"
                }
                props.CallbackRef(objCallbackData)
            }
            else if (
                (typeof(props.AuthorizedSubscription.BookCatID) !== 'undefined') &&
                (props.AuthorizedSubscription.BookCatID !== null) &&
                (parseInt(props.AuthorizedSubscription.BookCatID) > 0) &&
                (typeof(props.AuthorizedSubscription.BookSeqNo) !== 'undefined') &&
                (props.AuthorizedSubscription.BookSeqNo !== null) &&
                (parseInt(props.AuthorizedSubscription.BookSeqNo) > 0) &&
                (typeof(props.AuthorizedSubscription.LessonID) !== 'undefined') &&
                (props.AuthorizedSubscription.LessonID !== null) &&
                (parseInt(props.AuthorizedSubscription.LessonID) > 0) &&
                (typeof(props.AuthorizedSubscription.LUCatSeqNo) !== 'undefined') &&
                (props.AuthorizedSubscription.LUCatSeqNo !== null) &&
                (parseInt(props.AuthorizedSubscription.LUCatSeqNo) > 0)
                )
            {
                let blnExpired = window.Globals.CheckAuthorized(window.gSession.Acc.AccountAuthorized
                                    , props.AuthorizedSubscription.BookCatID
                                    , parseInt(props.AuthorizedSubscription.BookSeqNo))

                if (!blnExpired)
                {
                    let strLessonID = props.AuthorizedSubscription.LessonID.PadLeft(5)
                    let objLocationState = {
                        "BookSeqNo": props.AuthorizedSubscription.BookSeqNo,
                        "LessonID": strLessonID,
                        "LUCatSeqNo": props.AuthorizedSubscription.LUCatSeqNo
                    }
                    console.log("GoToLU objLocationState: ", objLocationState);
                    
                    let objCallbackData = {
                        "Action": "GoToLearningUnit4Settings",
                        "LocationState": objLocationState
                    }
                    props.CallbackRef(objCallbackData)
                }
            }
        } // end of if (props.AuthorizedSubscription !== null)

        console.log(COMP_NAME + ".GetAccountAuthorizedAfterProcess End");

        setCode01InputValue("")
        setCode02InputValue("")
        setCode03InputValue("")
        setCode04InputValue("")
        setUpdateDataTime(new Date().getTime())

        if (mblnIsExecuteExit)
        {
            mblnIsExecuteExit = false
            // ExecuteExit()
        }
    } // end of GetAccountAuthorizedAfterProcess

    /*===========================================
    summary: 輸入授權碼 後續流程 
    remarks: 000 Tim 2021/11/17 Create
    ===========================================*/
    function AuthProvisioningAfterProcess ()
    {   
        console.log(COMP_NAME + ".AuthProvisioningAfterProcess")

        let objAlertObject = {
            Header: "",
            Body: window.gAppUI.MSG_SubmitSuccess,
            ShowCloseButton: false,
            CallbackRef: SubmitSuccessAlertCallBack,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)

        mobjCallParam = null
    } // end of AuthProvisioningAfterProcess
    // #endregion Web Service After Process

    // #region Web Service 
    /*===========================================
    summary: 輸入授權碼
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function AuthProvisioning ()
    {
        console.log(COMP_NAME + ".AuthProvisioning")

        let objRetryFuncRef = AuthProvisioning
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = AuthProvisioningCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_AuthProvisioning)

            let objCallData = {
                "Func": "AuthProvisioning",
                "AuthCode": mobjCallParam.AuthCode
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of AuthProvisioning

    /*===========================================
    summary: 輸入授權碼 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function AuthProvisioningCallback (Return)
    {
        console.log(COMP_NAME + ".AuthProvisioningCallback")
        
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_AuthProvisioning_No
        let strErrorTitle = window.gAppUI.ERR_AuthProvisioning_Title
        let strErrMsg = window.gAppUI.ERR_AuthProvisioning_Msg

        let blnExceptionError = false
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                case window.gConst.WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_PROVISONED:         // -120055 已被開通 
                    strErrorTitle = window.gAppUI.ERR_AuthProvisioningRedeemed_Title
                    strErrMsg = '(' + window.gAppUI.ERR_AuthProvisioningRedeemed_No.toString() + ') ' + window.gAppUI.ERR_AuthProvisioningRedeemed_Msg + ' (' + Return.CalledErrNo + ')'
                    blnExceptionError = true
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_AUTH_PROVISIONING_EXPIRED:            // -120056 已過期
                    strErrorTitle = window.gAppUI.ERR_AuthProvisioningExpire_Title
                    strErrMsg = '(' + window.gAppUI.ERR_AuthProvisioningExpire_No.toString() + ') ' + window.gAppUI.ERR_AuthProvisioningExpire_Msg + ' (' + Return.CalledErrNo + ')'
                    blnExceptionError = true
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            } // end of switch (Return.CalledErrNo)

            if (blnExceptionError)
            {
                // 有需要 另外跳 錯誤訊息
                console.log("AuthProvisioningCallback: ExceptionError")

                let objAlertObject = {
                    Header: strErrorTitle,
                    Body: strErrMsg,
                    ShowCloseButton: false,
                    CallbackRef: null,
                    Buttons: [
                        {
                            Text: PackageVariablesLibs.UISettings.BTN_OK,
                            AutoFocus: true
                        }
                    ]
                }
                ShowAlert(objAlertObject)
            } // end of if (blnExceptionError)

            console.log("AuthProvisioningCallback: ErrNo: ", Return.ErrNo)
            console.log("AuthProvisioningCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("AuthProvisioningCallback Return.Data: ", Return.Data)

            AuthProvisioningAfterProcess()
        }
    } // end of AuthProvisioningCallback

    /*===========================================
    summary: 取得 使用者 授權
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetAccountAuthorized ()
    {
        let objRetryFuncRef = GetAccountAuthorized
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = GetAccountAuthorizedCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_GetAccountAuthorized)

            let objCallData = {
                "Func": "GetAccountAuthorized",
                "BundleID": mobjCallParam.BundleID,
                "AppVersion": mobjCallParam.AppVersion,
                "BookCategoryID": mobjCallParam.BookCategoryID
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of GetAccountAuthorized

    /*===========================================
    summary: 取得 使用者 授權 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function GetAccountAuthorizedCallback (Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_GetAccountAuthorized_No
        let strErrorTitle = window.gAppUI.ERR_GetAccountAuthorized_Title
        let strErrMsg = window.gAppUI.ERR_GetAccountAuthorized_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("GetAccountAuthorizedCallback: ErrNo: ", Return.ErrNo)
            console.log("GetAccountAuthorizedCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("GetAccountAuthorizedCallback Return.Data: ", Return.Data)

            GetAccountAuthorizedAfterProcess(Return.Data)
        }
    } // end of GetAccountAuthorizedCallback

    /*===========================================
    summary: 更新 按鈕 計次
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function UpdateProductCounter ()
    {
        let objRetryFuncRef = UpdateProductCounter
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = UpdateProductCounterCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_UpdateProductCounter)

            let objCallData = {
                "Func": "UpdateProductCounter",
                "AccountID": mobjCallParam.AccountID,
                "CouterType": mobjCallParam.CouterType, // 1. Trial 頁面 產品 點擊 統計 2: DCP Reminder 3: Subscription
                "ItemType": mobjCallParam.ItemType      // 各按鈕編號 
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of UpdateProductCounter

    /*===========================================
    summary: 更新 按鈕 計次 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function UpdateProductCounterCallback (Return, InstructionInfo)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_UpdateProductCounter_No
        let strErrorTitle = window.gAppUI.ERR_UpdateProductCounter_Title
        let strErrMsg = window.gAppUI.ERR_UpdateProductCounter_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("UpdateProductCounterCallback: ErrNo: ", Return.ErrNo)
            console.log("UpdateProductCounterCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("UpdateProductCounterCallback Return.Data: ", Return.Data)

            UpdateProductCounterAfterProcess()
        }
    } // end of UpdateProductCounterCallback

    /*===========================================
    summary: 儲存 帳號設定 
            (更新 按鈕 計次之後，就會跳寫入成功，
                所以 這邊 不使用Loading mask
                直接在背景做掉)
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SetAccountPreferences ()
    {
        let objRetryFuncRef = SetAccountPreferences
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SetAccountPreferencesCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY;

            // // Open Loading mask with message
            // OpenLoadingMask(window.gAppUI.MSG_LoadMask_SetAccountPreferences)

            let objCallData = {
                "Func": "SetAccountPreferences",
                "PrefList": JSON.stringify(mobjCallParam.AccPreferences)
            };

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SetAccountPreferences

    /*===========================================
    summary: 儲存 帳號設定 Callback
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function SetAccountPreferencesCallback (Return, InstructionInfo)
    {
        // // Close Loading mask        
        // CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SetAccountPreferences_No
        let strErrorTitle = window.gAppUI.ERR_SetAccountPreferences_Title
        let strErrMsg = window.gAppUI.ERR_SetAccountPreferences_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                // case customized error case:
                //     break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SetAccountPreferencesCallback: ErrNo: ", Return.ErrNo)
            console.log("SetAccountPreferencesCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SetAccountPreferencesCallback Return.Data: ", Return.Data)

            SetAccountPreferencesAfterProcess()
        }
    } // end of SetAccountPreferencesCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Content App Product Text 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentAppSubscriptionButton()
    {
        return(
            <div className={cssSubscription.btnAppSubscription}>
                {window.gAppUI.BTN_Buy}
            </div>
        )
    } // end of ComponentAppSubscriptionButton
                
    /*===========================================
    summary: Content App Product Expire Info 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentAppProductExpireInfo( {BookSeqNo} )
    {
        let objAuthorized = GetAuthorizedObject(BookSeqNo)

        if (
            (objAuthorized !== null) &&
            (typeof(objAuthorized.ExpiredTime) !== 'undefined') &&
            (objAuthorized.ExpiredTime !== null) &&
            (objAuthorized.ExpiredTime !== "") &&
            (objAuthorized.ExpiredTime !== "2000-01-01 00:00:00")    // 這個代表後端設定 取消授權   Tim22.12.05
            )
        {
            let datExpired = objAuthorized.ExpiredTime.ToUTC()
            let strExpired = datExpired.FormateBCDisplayDate().replace(/-/g, '/')

            return(
                <>
                    <div className={cssSubscription.divAppProductExpireBy}>
                        {window.gAppUI.LBL_ExpireBy}
                    </div>
                    <div className={cssSubscription.divAppProductExpireTime}>
                        {strExpired}
                    </div>
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentAppProductExpireInfo 

    /*===========================================
    summary: Content App Product Text 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentAppProductText( {BookName} )
    {
        return(
            <div className={cssSubscription.divAppProductText}>
                {BookName}
            </div>
        )
    } // end of ComponentAppProductText
                
    /*===========================================
    summary: Content App Product Image 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
             001 Tim 2022/09/01 移除 App 取得資料 流程，改讀 Web路徑 取圖
    ===========================================*/
    function ComponentAppProductImage( {ImageFN} )
    {
        let strBookCatID = window.gSession.App.BookCatID.toString().PadLeft(2)
        let strImageFN = ImageFN
        strImageFN += window.gConst.IMG_VER_POSTFIX + process.env.REACT_APP_LOG_VERSION

        let strUrl = PackageVariablesLibs.SysConfig.FileServerURL + "BookCategory" + strBookCatID + "/image/" + strImageFN

        let objStyle = {
            backgroundImage: 'url(' + strUrl + ')'
        }

        return(
            <div className={cssSubscription.divAppProductImage} style={objStyle}/>
        )
    } // end of ComponentAppProductImage
                
    /*===========================================
    summary: Content Web Product Due Today 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebProductOrderNowButton( {ProductDefault} )
    {
        return(
            <div className={GetOrderNowButtonCls(ProductDefault)}>
                {window.gAppUI.LBL_OrderNow}
            </div>
        )
    } // end of ComponentWebProductOrderNowButton

    /*===========================================
    summary: Content Web Product Due Today 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebProductDueToday( {ProductPrice} )
    {
        let strDueToday = "$" + ProductPrice + " " + window.gAppUI.LBL_DueToday

        return(
            <div className={cssSubscription.divDueToday}>
                {strDueToday}
            </div>
        )
    } // end of ComponentWebProductDueToday

    /*===========================================
    summary: Content Web Product Price Per Month 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebProductPricePerMonth( {ProductPricePerMonth} )
    {
        return(
            <>
                <div className={cssSubscription.divPricePerMonthValueMain}>
                    <div className={cssSubscription.divPricePerMonthSymbol}>
                        $
                    </div>
                    <div className={cssSubscription.divPricePerMonthValue}>
                        {ProductPricePerMonth}
                    </div>                                
                </div>

                <div className={cssSubscription.divPricePerMonth}>
                    {window.gAppUI.LBL_PerMonth}
                </div>

                <div className={cssSubscription.divMonthFree}>
                    {window.gAppUI.LBL_MonthFree}
                </div>
            </>
        )
    } // end of ComponentWebProductPricePerMonth

    /*===========================================
    summary: Content Web Product Program Text 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebProductProgramText( {ProductProgram} )
    {
        return(
            <div className={cssSubscription.divProgramText}>
                {ProductProgram}
            </div>
        )
    } // end of ComponentWebProductProgramText                

    /*===========================================
    summary: Content Web Product Default Tip 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebProductDefaultTip( {ProductDefault} )
    {
        if (ProductDefault === 1)
        {
            return(
                <div className={cssSubscription.divWebProductDefaultTip}/>
            )
        }
        else
        {
            return ""
        }
    } // end of ComponentWebProductDefaultTip

    /*===========================================
    summary: Content Web Subscription Memo 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentWebSubscriptionMemo()
    {
        return(
            <div className={cssSubscription.divWebSubscriptionMemo}>
                {window.gAppUI.LBL_WebSubscriptionDesc}
            </div>
        )
    } // end of ComponentWebSubscriptionMemo

    /*===========================================
    summary: Content Authorization Memo 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentAuthorizationMemo()
    {
        return(
            <div className={cssSubscription.divMemo}>
                {window.gAppUI.LBL_AuthorizationMemo}
            </div>
        )
    } // end of ComponentAuthorizationMemo                

    /*===========================================
    summary: Content Submit Button 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentSubmitButton()
    {
        return(
            <div className={cssSubscription.btnSubmit} onClick={() => SubmitOnTapHandler()}>
                {window.gAppUI.BTN_Submit}
            </div>
        )
    } // end of ComponentSubmitButton

    /*===========================================
    summary: Content Code Input 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentCodeInput( {TextID} )
    {   
        let strID = "TxtCode0" + TextID.toString()
        let strInputValue = ""
        switch (TextID) 
        {
            case 2:
                strInputValue = code02InputValue
                break
            case 3:
                strInputValue = code03InputValue
                break
            case 4:
                strInputValue = code04InputValue
                break
            case 1:
            default:
                strInputValue = code01InputValue
                break
        } // end of switch

        return(
            <>
                <label htmlFor={strID} className={cssSubscription.divHidden}>
                    {window.gAppUI.LBL_LinkPlaceHolder}
                </label>

                <input id={strID} className={cssSubscription.txtCode}
                    type="text" 
                    value={strInputValue}
                    onChange={(event) => CodeChangeHandler(event, TextID)}
                    maxLength={MAX_CODE_CHARACHERS}
                    required
                />
            </>
        )
    } // end of ComponentCodeInput
                        
    /*===========================================
    summary: Content Title 顯示Component  
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function ComponentContentTitle( {Title} )
    {   
        return(
            <>
                <div className={cssSubscription.divContentTitle}>
                    {Title}
                </div>

                <div className={cssSubscription.divTitleLine}/>
            </>
        )
    } // end of ComponentContentTitle
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Render App 產品元件 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderAppProductUnitWrapper(BookData, BookIndex)
    {
        return (
            <>
                <ComponentAppProductImage ImageFN={BookData.MajorLandscapeImgFN} />

                <ComponentAppProductText BookName={BookData.Name} />
                
                <ComponentAppProductExpireInfo BookSeqNo={BookIndex + 1} />

                <ComponentAppSubscriptionButton />
            </>
        )
    } // end of RenderAppProductUnitWrapper

    /*===========================================
    summary: Render App Content 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderAppContentWrapper()
    {
        return (
            <>
                <ComponentContentTitle Title={window.gAppUI.LBL_BookList} />

                <div className={cssSubscription.divAppSubscriptionMain}>
                    {window.gSession.App.BookCategoryDef.Book.map((BookData, BookIndex) =>
                        <div key={BookIndex} className={GetAppProductUnitCls(BookIndex)} onClick={() => AppProductUnitOnTapHandler(BookIndex)}>
                            {RenderAppProductUnitWrapper(BookData, BookIndex)}
                        </div>
                    )}
                </div>
            </>
        )
    } // end of RenderAppContentWrapper

    /*===========================================
    summary: Render Web 產品元件 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderWebProductUnitWrapper(ProductData)
    {
        return (
            <>
                <ComponentWebProductDefaultTip ProductDefault={parseInt(ProductData.Default)}/>
                
                <ComponentWebProductProgramText ProductProgram={ProductData.Program}/>

                <ComponentWebProductPricePerMonth ProductPricePerMonth={ProductData.PricePerMonth}/>

                <ComponentWebProductDueToday ProductPrice={ProductData.Price}/>

                <ComponentWebProductOrderNowButton ProductDefault={parseInt(ProductData.Default)}/>
            </>
        )
    } // end of RenderWebProductUnitWrapper

    /*===========================================
    summary: Render Web Subscription 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderWebSubscriptionWrapper()
    {
        return (
            <div className={cssSubscription.divWebSubscriptionMain}>
                <ComponentContentTitle Title={window.gAppUI.LBL_Subscription} />

                <ComponentWebSubscriptionMemo />
                
                <div className={cssSubscription.divWebProductContent}>
                    {window.gSession.Acc.SubscriptionReminder.Reminder.map((ReminderData, ReminderIndex) =>
                        <div key={ReminderIndex} className={cssSubscription.divWebProductUnit} 
                                onClick={() => WebProductUnitOnTapHandler(ReminderIndex)}>
                            {RenderWebProductUnitWrapper(ReminderData)}
                        </div>
                    )}
                </div> 
            </div>
        )
    } // end of RenderWebSubscriptionWrapper

    /*===========================================
    summary: Render 授權碼 輸入區 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderAuthorizationCodeWrapper()
    {
        return (
            <div className={cssSubscription.divAuthorizationCodeMain}>
                <ComponentContentTitle Title={window.gAppUI.LBL_AuthorizationCode} />

                <div className={cssSubscription.divCodeMain}>
                    <div className={cssSubscription.divCodeInputArea}>
                        <ComponentCodeInput TextID={1} />
                        <ComponentCodeInput TextID={2} />
                        <ComponentCodeInput TextID={3} />
                        <ComponentCodeInput TextID={4} />
                    </div>

                    <ComponentSubmitButton />
                </div>

                <ComponentAuthorizationMemo />
            </div>
        )
    } // end of RenderAuthorizationCodeWrapper

    /*===========================================
    summary: Render Web Content 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderWebContentWrapper()
    {
        return (
            <>
                {RenderAuthorizationCodeWrapper()}

                {RenderWebSubscriptionWrapper()}
            </>
        )
    } // end of RenderWebContentWrapper

    /*===========================================
    summary: Render Subscription 內容 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        let objBlock = null

        if (!window.gSession.App.InApp)
        {
            objBlock = RenderWebContentWrapper()
        }
        else
        {
            objBlock = RenderAppContentWrapper()
        }

        return objBlock
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/15 Create
    ===========================================*/
    function RenderMainWrapper(StateUpdateDataTime)
    {
        if (StateUpdateDataTime > 0)
        {
            return (
                <>
                    {RenderContentWrapper()}
                </>
            )
        }
        else
        {
            return ""
        }
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper(updateDataTime)}
        </>
    )
    // #endregion Render
}
export default Subscription